export const initialState = {
    is_loading: true,
    job_invoices: [],
    current_page: 1,
    serach_text: '',
    sort_key: '',
    sort_direction: '',
    total_invoices: 0,
    total_pages: 0,
}